// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_cz-6";
export var emphasizeQuantity = "_cz-3";
export var flatBottomCorners = "_cz-5";
export var productImage = "_cz-0";
export var quantityContainer = "_cz-2";
export var tooltip = "_cz-1";
export var wrapAndEllipsesOverflow = "_cz-4";